import React from "react";

const ILLUSTRAZIONI = {
  progetti: (
    <svg viewBox="0 0 120 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="10" y="20" width="100" height="50" rx="8" fill="#ede9fe" stroke="#c4b5fd" strokeWidth="1.5"/>
      <rect x="20" y="30" width="35" height="5" rx="2.5" fill="#a78bfa"/>
      <rect x="20" y="40" width="25" height="4" rx="2" fill="#c4b5fd"/>
      <rect x="20" y="50" width="30" height="4" rx="2" fill="#c4b5fd"/>
      <circle cx="85" cy="45" r="12" fill="#7c3aed" opacity=".15"/>
      <path d="M80 45h10M85 40v10" stroke="#7c3aed" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  attivita: (
    <svg viewBox="0 0 120 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="15" y="15" width="90" height="50" rx="8" fill="#ede9fe" stroke="#c4b5fd" strokeWidth="1.5"/>
      <circle cx="30" cy="30" r="5" fill="#c4b5fd"/>
      <rect x="42" y="27" width="45" height="5" rx="2.5" fill="#a78bfa"/>
      <circle cx="30" cy="45" r="5" fill="#c4b5fd"/>
      <rect x="42" y="42" width="35" height="5" rx="2.5" fill="#c4b5fd"/>
      <circle cx="30" cy="57" r="5" fill="#e5e7eb"/>
      <rect x="42" y="54" width="40" height="5" rx="2.5" fill="#e5e7eb"/>
    </svg>
  ),
  documenti: (
    <svg viewBox="0 0 120 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="35" y="10" width="55" height="65" rx="6" fill="#ede9fe" stroke="#c4b5fd" strokeWidth="1.5"/>
      <rect x="30" y="15" width="55" height="65" rx="6" fill="#f5f3ff" stroke="#c4b5fd" strokeWidth="1.5"/>
      <rect x="42" y="30" width="30" height="4" rx="2" fill="#a78bfa"/>
      <rect x="42" y="40" width="25" height="3" rx="1.5" fill="#c4b5fd"/>
      <rect x="42" y="48" width="28" height="3" rx="1.5" fill="#c4b5fd"/>
      <rect x="42" y="56" width="20" height="3" rx="1.5" fill="#ddd6fe"/>
    </svg>
  ),
  generico: (
    <svg viewBox="0 0 120 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="60" cy="40" r="28" fill="#ede9fe" stroke="#c4b5fd" strokeWidth="1.5"/>
      <path d="M60 28v16M60 50v4" stroke="#7c3aed" strokeWidth="2.5" strokeLinecap="round"/>
    </svg>
  ),
  feed: (
    <svg viewBox="0 0 120 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="10" y="10" width="100" height="18" rx="6" fill="#ede9fe" stroke="#c4b5fd" strokeWidth="1.5"/>
      <rect x="10" y="33" width="100" height="18" rx="6" fill="#f5f3ff" stroke="#e5e7eb" strokeWidth="1.5"/>
      <rect x="10" y="56" width="100" height="18" rx="6" fill="#f5f3ff" stroke="#e5e7eb" strokeWidth="1.5"/>
      <circle cx="22" cy="19" r="5" fill="#a78bfa"/>
      <rect x="32" y="16" width="40" height="4" rx="2" fill="#a78bfa"/>
      <rect x="32" y="22" width="25" height="3" rx="1.5" fill="#c4b5fd"/>
    </svg>
  ),
};

/**
 * EmptyState — stato vuoto uniforme per tutta Nexiora
 */
export function EmptyState({
  tipo="generico",
  titolo="Nessun elemento",
  descrizione="",
  azione=null,    // { label, onClick }
  compact=false,
}) {
  return (
    <div style={{
      display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center",
      padding: compact ? "24px 16px" : "48px 24px",
      textAlign:"center", color:"#9ca3af"
    }}>
      <div style={{width: compact?80:120, marginBottom:16, opacity:.8}}>
        {ILLUSTRAZIONI[tipo]||ILLUSTRAZIONI.generico}
      </div>
      <div style={{fontSize: compact?13:15, fontWeight:700, color:"#374151", marginBottom:6}}>
        {titolo}
      </div>
      {descrizione && (
        <div style={{fontSize:12, color:"#9ca3af", maxWidth:280, lineHeight:1.6, marginBottom:azione?16:0}}>
          {descrizione}
        </div>
      )}
      {azione && (
        <button onClick={azione.onClick}
          style={{
            marginTop:4, padding:"8px 18px", border:"none", borderRadius:8,
            background:"#7c3aed", color:"#fff", fontSize:12, fontWeight:700,
            cursor:"pointer", fontFamily:"'Inter',sans-serif"
          }}>
          {azione.label}
        </button>
      )}
    </div>
  );
}
